// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"b69ea7d2","451":"d6865ff9"}[chunkId] + ".css";
};